module.exports = __webpack_public_path__ + "img/New PACI Flow AR - Enable Authentication - 2.b393ff21.png";